import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { verifySvCode } from '../../../services/private/site-visit.service';

const numberOfDigits = 6
const SiteVisitOTPModal = ({
    show,
    closeModal,
    phoneNumber = '9XXXXXXXXXX',
    email = 'name@email.com',
    onContinue,
    setShowVerifyIdentityModal,
    projectId
}) => {
    const [hasCode, setHasCode] = useState(true);
    const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
    const otpBoxReference = useRef([]);

    function handleChange(value, index) {
        // if (value) {
        let newArr = [...otp];
        const inputValue = value;
        // Allow only one digit between 0 and 9
        if (inputValue === '' || (inputValue.length === 1 && /^[0-9]$/.test(inputValue))) {
            //   setValue(inputValue);
            newArr[index] = inputValue
            setOtp(newArr);
        }

        if (value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus()
        }
        // }
    }

    function handleBackspaceAndEnter(e, index) {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpBoxReference.current[index - 1].focus()
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus()
        }
    }

    const handleContinue = async () => {
        const payload = {
            "sv_code": otp.join(''),
            "project_id": projectId
        }
        const res = await verifySvCode(payload);
        if (res.data.status === 200) {
            setShowVerifyIdentityModal(true)
            closeModal()
        }
    };

    return (
        <Modal
            size="xl"
            show={show}
            onHide={closeModal}
            centered
            dialogClassName="!w-[640px] modal-radius import-modals"
        >
            <div className="bg-white rounded-2xl p-6 sm:p-8">
                <div className="flex items-start justify-between">
                    <h2 className="text-xl sm:text-2xl font-semibold text-slate-900">
                        Do you have a Site Visit Code?
                    </h2>
                    <button
                        type="button"
                        onClick={closeModal}
                        className="ml-4 text-slate-400 hover:text-slate-600 text-2xl leading-none"
                    >
                        &times;
                    </button>
                </div>

                <div className="mt-6 space-y-4 border border-slate-200 !p-4 !rounded-2xl">
                    {/* Yes, I have a Site Visit Code */}
                    <button
                        type="button"
                        onClick={() => setHasCode(true)}
                        className={`w-full text-left rounded-2xl border p-4 sm:p-5 transition-all ${hasCode
                            ? 'border-blue-600 bg-white shadow-[0_18px_40px_rgba(15,23,42,0.12)]'
                            : 'border-slate-200 bg-slate-50 hover:border-slate-300'
                            }`}
                    >
                        <div className="flex items-start !gap-3">

                            <div className="flex-1">
                                <p className="text-sm sm:text-base font-medium text-[#344054] mb-0">
                                    Yes, I have a Site Visit Code
                                </p>

                                <p className="text-xs sm:text-sm text-grey-500 mb-0">
                                    Enter the code below to fetch customer and CP details instantly.
                                </p>
                                <div className="border-t border-slate-200 !my-3" />
                                <p className=" text-xs sm:text-sm text-grey-500 mb-0">
                                    Site visit details were shared via SMS on{' '}
                                    <span className="font-semibold text-blue-600">
                                        {phoneNumber}
                                    </span>{' '}
                                    or email at{' '}
                                    <span className="font-semibold text-blue-600 underline">
                                        {email}
                                    </span>{' '}
                                    when the visit was scheduled.
                                </p>

                                <div className="!mt-4 flex flex-col !gap-2">
                                    <div className="grid grid-cols-6 gap-2 sm:gap-3 max-w-xs">
                                        {otp.map((digit, index) => (
                                            <input key={index} value={digit} maxLength={1} min={0} max={9} step={1} type='number'
                                                onChange={(e) => handleChange(e.target.value
                                                    // .replace(/^0+/g, '')
                                                    .replace(/[^0-9]/g, ''), index)}
                                                onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                                                ref={(reference) => (otpBoxReference.current[index] = reference)}
                                                className="h-10 w-10 sm:h-12 sm:w-12 rounded-xl border border-slate-300 bg-white text-center text-base sm:text-lg font-semibold text-slate-900 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            />
                                        ))}

                                    </div>
                                    <p className="text-xs text-grey-500">
                                        Can’t find the code? Check the Plus App lead card or
                                        contact the Site Team for help.
                                    </p>
                                </div>
                            </div>
                            <span
                                className={`mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full border-2 ${hasCode
                                    ? 'border-blue-600'
                                    : 'border-slate-300 bg-white'
                                    }`}
                            >
                                {hasCode && (
                                    <span className="h-2.5 w-2.5 rounded-full bg-blue-600" />
                                )}
                            </span>
                        </div>
                    </button>

                    {/* No, proceed without a Site Visit Code */}
                    <button
                        type="button"
                        onClick={() => setHasCode(false)}
                        className={`w-full text-left rounded-2xl border p-4 sm:p-5 transition-all ${!hasCode
                            ? 'border-blue-600 bg-white shadow-[0_18px_40px_rgba(15,23,42,0.12)]'
                            : 'border-slate-200 bg-slate-50 hover:border-slate-300'
                            }`}
                    >
                        <div className="flex items-start justify-between !gap-3">
                            <div>
                                <p className="text-sm sm:text-base font-medium text-[#344054] mb-0">
                                    No, proceed without a Site Visit Code
                                </p>
                                <p className="!mt-1 text-xs sm:text-sm text-grey-500 mb-0">
                                    Enter customer information and verify identity on site.
                                </p>
                            </div>
                            <span
                                className={`mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full border-2 ${!hasCode
                                    ? 'border-blue-600'
                                    : 'border-slate-300 bg-white'
                                    }`}
                            >
                                {!hasCode && (
                                    <span className="h-2.5 w-2.5 rounded-full bg-blue-600" />
                                )}
                            </span>
                        </div>
                    </button>
                </div>

                <div className="mt-6 w-full sm:mt-8 flex flex-col-reverse sm:flex-row sm:justify-between gap-3">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="w-full sm:w-1/2 rounded-xl border border-slate-300 bg-white !px-4 !py-2.5 text-sm sm:text-base font-semibold text-slate-700 hover:bg-slate-50"
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            handleContinue()
                        }}
                        className="w-full sm:w-1/2 rounded-xl bg-blue-600 !px-4 !py-2.5 text-sm sm:text-base font-semibold text-white shadow-sm hover:bg-blue-700"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SiteVisitOTPModal;